import { Box } from "@mui/material";
import AnnotatedBlock from "../AnnotatedBlock";
import { BlockEntity, BlockSurroundings } from "Backend";
import { Position } from "components/RainbowText";
import theme from "theme";

export interface BlockWithSurroundingsProps {
  preSurroundings: BlockSurroundings[];
  postSurroundings: BlockSurroundings[];
  blockText: string;
  mainHit?: Position;
  entities: BlockEntity[];
}

const BlockWithSurroundings = (props: BlockWithSurroundingsProps) => {
  const { blockText, preSurroundings, postSurroundings, mainHit, entities } = props;

  const validMainHit = mainHit?.start === -1 || mainHit?.end === -1 ? undefined : mainHit;

  return (
    <Box
      sx={{
        padding: theme.spacing(1),
        fontSize: "10pt",
      }}>
      {preSurroundings.map((pre, idx) => (
        <AnnotatedBlock key={idx} text={pre.block.text} entities={pre.entities} />
      ))}
      <AnnotatedBlock text={blockText} entities={entities} mainHit={validMainHit} />
      {postSurroundings.map((post, idx) => (
        <AnnotatedBlock key={idx} text={post.block.text} entities={post.entities} />
      ))}
    </Box>
  );
};

export default BlockWithSurroundings;
